export default __webpack_public_path__ + "static/media/guide_notif.93120572.png";